import { defineMessages } from 'react-intl-next';

export const colorMessages = defineMessages({
  'color-picker-label.greyLight': {
    id: 'color-picker-label.greyLight',
    defaultMessage: 'Light gray',
    description: 'The tooltip label for the greyLight color in the color picker.'
  },
  'color-picker-label.blueLight': {
    id: 'color-picker-label.blueLight',
    defaultMessage: 'Light blue',
    description: 'The tooltip label for the blueLight color in the color picker.'
  },
  'color-picker-label.tealLight': {
    id: 'color-picker-label.tealLight',
    defaultMessage: 'Light teal',
    description: 'The tooltip label for the tealLight color in the color picker.'
  },
  'color-picker-label.greenLight': {
    id: 'color-picker-label.greenLight',
    defaultMessage: 'Light green',
    description: 'The tooltip label for the greenLight color in the color picker.'
  },
  'color-picker-label.limeLight': {
    id: 'color-picker-label.limeLight',
    defaultMessage: 'Light lime',
    description: 'The tooltip label for the limeLight color in the color picker.'
  },
  'color-picker-label.purpleLight': {
    id: 'color-picker-label.purpleLight',
    defaultMessage: 'Light purple',
    description: 'The tooltip label for the purpleLight color in the color picker.'
  },
  'color-picker-label.magentaLight': {
    id: 'color-picker-label.magentaLight',
    defaultMessage: 'Light magenta',
    description: 'The tooltip label for the magentaLight color in the color picker.'
  },
  'color-picker-label.redLight': {
    id: 'color-picker-label.redLight',
    defaultMessage: 'Light red',
    description: 'The tooltip label for the redLight color in the color picker.'
  },
  'color-picker-label.orangeLight': {
    id: 'color-picker-label.orangeLight',
    defaultMessage: 'Light orange',
    description: 'The tooltip label for the orangeLight color in the color picker.'
  },
  'color-picker-label.yellowLight': {
    id: 'color-picker-label.yellowLight',
    defaultMessage: 'Light yellow',
    description: 'The tooltip label for the yellowLight color in the color picker.'
  },
  'color-picker-label.greyDark': {
    id: 'color-picker-label.greyDark',
    defaultMessage: 'Gray',
    description: 'The tooltip label for the greyDark color in the color picker.'
  },
  'color-picker-label.blueDark': {
    id: 'color-picker-label.blueDark',
    defaultMessage: 'Blue',
    description: 'The tooltip label for the blueDark color in the color picker.'
  },
  'color-picker-label.tealDark': {
    id: 'color-picker-label.tealDark',
    defaultMessage: 'Teal',
    description: 'The tooltip label for the tealDark color in the color picker.'
  },
  'color-picker-label.greenDark': {
    id: 'color-picker-label.greenDark',
    defaultMessage: 'Green',
    description: 'The tooltip label for the greenDark color in the color picker.'
  },
  'color-picker-label.limeDark': {
    id: 'color-picker-label.limeDark',
    defaultMessage: 'Lime',
    description: 'The tooltip label for the limeDark color in the color picker.'
  },
  'color-picker-label.purpleDark': {
    id: 'color-picker-label.purpleDark',
    defaultMessage: 'Purple',
    description: 'The tooltip label for the purpleDark color in the color picker.'
  },
  'color-picker-label.magentaDark': {
    id: 'color-picker-label.magentaDark',
    defaultMessage: 'Magenta',
    description: 'The tooltip label for the magentaDark color in the color picker.'
  },
  'color-picker-label.redDark': {
    id: 'color-picker-label.redDark',
    defaultMessage: 'Red',
    description: 'The tooltip label for the redDark color in the color picker.'
  },
  'color-picker-label.orangeDark': {
    id: 'color-picker-label.orangeDark',
    defaultMessage: 'Orange',
    description: 'The tooltip label for the orangeDark color in the color picker.'
  },
  'color-picker-label.yellowDark': {
    id: 'color-picker-label.yellowDark',
    defaultMessage: 'Yellow',
    description: 'The tooltip label for the yellowDark color in the color picker.'
  }
});
